<div
  class="table"
  [class.table--full-height]="verticalScroll() || fullHeight()"
>
  <procure-loading-indicator [active]="isLoading" />
  <div
    #wrapper
    class="table__wrapper"
    [class.table__wrapper--scroll-indicator-right]="scrollIndicatorRight"
    [class.table__wrapper--scroll-indicator-left]="scrollIndicatorLeft"
  >
    <div
      #scrollContainer
      class="table__scroll-container table__scroll-container--vertical"
      [class.table__scroll-container--vertical]="verticalScroll()"
      [class.table__scroll-container--full-height]="fullHeight()"
      (scroll)="scrollIndicators()"
    >
      <ng-content />
    </div>
  </div>
  <procure-paginator
    class="table__pagination"
    [length]="dataSourceLength"
    [hidden]="hidePagination"
    [pageSizes]="pageSizes"
    [disableAllOption]="disableAllOption"
  />
</div>
